export const toggleNavbarWhite = () => ({
    type: 'TOGGLE_NAVBAR_WHITE',
})

export const toggleNavbarTransparent = () => ({
    type: 'TOGGLE_NAVBAR_TRANSPARENT',
})